


























import { Component, Prop, Model, Watch } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import moment from 'moment'
import { DateRange, DateTermsItem } from '../../models/date-range-model'

@Component({
  name: 'HsDateRange',
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @Model('change', {
    default: () => {
      return {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      }
    },
  })
  readonly value: DateRange

  @Prop({
    default: () => {
      return ['TODAY', '-7_FT', '-14_FT']
    },
  })
  readonly terms: [number | string]

  @Prop({ default: false }) readonly hideTerms: boolean
  @Prop({ default: false }) readonly extendTerms: boolean
  @Prop({ default: undefined }) readonly term: number | string | undefined
  @Prop({ default: false }) disabled: boolean
  @Prop({ default: false }) fromToday: boolean
  @Prop({ default: undefined }) min: string
  @Prop({ default: undefined }) max: string

  dateRange: DateRange = {
    startDate: null,
    endDate: null,
  }

  dateToggleGroup: number | string | undefined = undefined
  dateToggleItems: DateTermsItem[] = []

  minDay: string = null
  maxDay: string = null

  TODAY: string
  YESTERDAY: string
  TOMORROW: string
  THIS_WEEK: DateRange
  LAST_WEEK: DateRange
  NEXT_WEEK: DateRange
  THIS_MONTH: DateRange
  LAST_MONTH: DateRange
  NEXT_MONTH: DateRange
  THIS_QUARTER: DateRange
  LAST_QUARTER: DateRange
  NEXT_QUARTER: DateRange
  THIS_YEAR: DateRange
  LAST_YEAR: DateRange
  NEXT_YEAR: DateRange

  initDate() {
    this.TODAY = moment().format('YYYY-MM-DD')
    this.YESTERDAY = moment().subtract(1, 'day').format('YYYY-MM-DD')
    this.TOMORROW = moment().add(1, 'day').format('YYYY-MM-DD')
    this.THIS_WEEK = {
      startDate: moment().startOf('week').format('YYYY-MM-DD'),
      endDate: moment().endOf('week').format('YYYY-MM-DD'),
    }
    this.LAST_WEEK = {
      startDate: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD'),
    }
    this.NEXT_WEEK = {
      startDate: moment().add(1, 'week').startOf('week').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'week').endOf('week').format('YYYY-MM-DD'),
    }
    this.THIS_MONTH = {
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
    }
    this.LAST_MONTH = {
      startDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    }
    this.NEXT_MONTH = {
      startDate: moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'month').endOf('month').format('YYYY-MM-DD'),
    }
    this.THIS_QUARTER = {
      startDate: moment().startOf('quarter').format('YYYY-MM-DD'),
      endDate: moment().endOf('quarter').format('YYYY-MM-DD'),
    }
    this.LAST_QUARTER = {
      startDate: moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD'),
    }
    this.NEXT_QUARTER = {
      startDate: moment().add(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'quarter').endOf('quarter').format('YYYY-MM-DD'),
    }
    this.THIS_YEAR = {
      startDate: moment().startOf('year').format('YYYY-MM-DD'),
      endDate: moment().endOf('year').format('YYYY-MM-DD'),
    }
    this.LAST_YEAR = {
      startDate: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'),
    }
    this.NEXT_YEAR = {
      startDate: moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'year').endOf('year').format('YYYY-MM-DD'),
    }
  }

  created() {
    this.initDate()
    this.init()
    this.initToggleGroup()
    if (this.term !== undefined) {
      this.dateToggleGroup = this.term
      this.onChangeTerms(this.dateToggleGroup)
    }
    this.minDay = (this.min || '') === '' ? null : this.min
    this.maxDay = (this.max || '') === '' ? null : this.max
  }

  init() {
    this.dateRange = {
      startDate: (this.value.startDate || '') === '' ? this.TODAY : this.value.startDate,
      endDate: (this.value.endDate || '') === '' ? this.TODAY : this.value.endDate,
    }
    this.dateToggleGroup = this.dateDuration(this.dateRange.startDate, this.dateRange.endDate)
  }

  dateDuration(startDate: string, endDate: string = this.TODAY): number | string {
    return moment.duration(moment(startDate).diff(moment(endDate))).asDays()
  }

  initToggleGroup() {
    this.dateToggleItems = []
    const beforePrefix = this.terms.length > 5 ? '-' : '지난 '
    const afterPrefix = this.terms.length > 5 ? '+' : '이후 '

    for (const term of this.terms) {
      const item: DateTermsItem = {
        text: '',
        value: undefined,
      }
      if (term === 0) {
        item.text = '당일'
        item.value = term
      } else if (typeof term === 'string') {
        if (term === 'TODAY') {
          item.text = '오늘'
          item.value = term
        } else if (term === 'YESTERDAY') {
          item.text = '어제'
          item.value = term
        } else if (term === 'TOMORROW') {
          item.text = '내일'
          item.value = term
        } else if (term === 'THIS_WEEK') {
          item.text = '이번주'
          item.value = term
        } else if (term === 'LAST_WEEK') {
          item.text = '저번주'
          item.value = term
        } else if (term === 'NEXT_WEEK') {
          item.text = '다음주'
          item.value = term
        } else if (term === 'THIS_MONTH') {
          item.text = '이번달'
          item.value = term
        } else if (term === 'LAST_MONTH') {
          item.text = '지난달'
          item.value = term
        } else if (term === 'NEXT_MONTH') {
          item.text = '다음달'
          item.value = term
        } else if (term === 'THIS_QUARTER') {
          item.text = '이번분기'
          item.value = term
        } else if (term === 'LAST_QUARTER') {
          item.text = '지난분기'
          item.value = term
        } else if (term === 'NEXT_QUARTER') {
          item.text = '다음분기'
          item.value = term
        } else if (term === 'THIS_YEAR') {
          item.text = '금년'
          item.value = term
        } else if (term === 'LAST_YEAR') {
          item.text = '작년'
          item.value = term
        } else if (term === 'NEXT_YEAR') {
          item.text = '내년'
          item.value = term
        } else {
          const keyword = term.split('_')
          const prefix = Number(keyword[0]) < 0 ? beforePrefix : afterPrefix
          if (keyword[1] === 'FT' && this.fromToday) {
            const ftPrefix = Number(keyword[0]) < 0 ? '지난 ' : '이후 '
            item.text = ftPrefix + Math.abs(Number(keyword[0])) + '일'
            item.value = term
          } /* else if (keyword[1] === 'year') {
            item.text = prefix + Math.abs(Number(keyword[0])) + '년'
            item.value = term
          } else if (keyword[1] === 'month') {
            item.text = prefix + Math.abs(Number(keyword[0])) + '개월'
            item.value = term
          } else if (keyword[1] === 'week') {
            item.text = prefix + Math.abs(Number(keyword[0])) + '주'
            item.value = term
          } */ else {
            item.text = 'NaN'
            item.value = NaN
          }
        }
      } else if (typeof term === 'number') {
        const prefix = term < 0 ? beforePrefix : afterPrefix
        item.text = prefix + Math.abs(term) + '일'
        item.value = term
      }
      this.dateToggleItems.push(item)
    }
    // console.log('init terms[]', this.dateToggleItems)
  }

  onChangeToggle(val) {
    // console.log(val)
    this.onChangeTerms(val)
  }

  testBoolean: boolean

  onChangeDate() {
    let startDate = this.dateRange.startDate
    const endDate = this.dateRange.endDate
    // isBefore1n
    let dateTerm: number | string = this.dateDuration(startDate, endDate)

    // console.log('onChangeDate', dateTerm, startDate, endDate, moment(endDate).isBefore(startDate))
    // 종료일자가 시작일자보다 이전일경우 시작일자 종료일자로 변경
    if (moment(endDate).isBefore(startDate)) {
      this.dateRange.startDate = endDate
      startDate = this.dateRange.startDate
    }

    if (startDate === this.TODAY && endDate === this.TODAY) {
      dateTerm = 'TODAY'
    } else if (startDate === this.YESTERDAY && endDate === this.YESTERDAY) {
      dateTerm = 'YESTERDAY'
    } else if (startDate === this.TOMORROW && endDate === this.TOMORROW) {
      dateTerm = 'TOMORROW'
    } else if (startDate === this.THIS_WEEK.startDate && endDate === this.THIS_WEEK.endDate) {
      dateTerm = 'THIS_WEEK'
    } else if (startDate === this.LAST_WEEK.startDate && endDate === this.LAST_WEEK.endDate) {
      dateTerm = 'LAST_WEEK'
    } else if (startDate === this.NEXT_WEEK.startDate && endDate === this.NEXT_WEEK.endDate) {
      dateTerm = 'NEXT_WEEK'
    } else if (startDate === this.THIS_MONTH.startDate && endDate === this.THIS_MONTH.endDate) {
      dateTerm = 'THIS_MONTH'
    } else if (startDate === this.LAST_MONTH.startDate && endDate === this.LAST_MONTH.endDate) {
      dateTerm = 'LAST_MONTH'
    } else if (startDate === this.NEXT_MONTH.startDate && endDate === this.NEXT_MONTH.endDate) {
      dateTerm = 'NEXT_MONTH'
    } else if (startDate === this.THIS_QUARTER.startDate && endDate === this.THIS_QUARTER.endDate) {
      dateTerm = 'THIS_QUARTER'
    } else if (startDate === this.LAST_QUARTER.startDate && endDate === this.LAST_QUARTER.endDate) {
      dateTerm = 'LAST_QUARTER'
    } else if (startDate === this.NEXT_QUARTER.startDate && endDate === this.NEXT_QUARTER.endDate) {
      dateTerm = 'NEXT_QUARTER'
    } else if (startDate === this.THIS_YEAR.startDate && endDate === this.THIS_YEAR.endDate) {
      dateTerm = 'THIS_YEAR'
    } else if (startDate === this.LAST_YEAR.startDate && endDate === this.LAST_YEAR.endDate) {
      dateTerm = 'LAST_YEAR'
    } else if (startDate === this.NEXT_YEAR.startDate && endDate === this.NEXT_YEAR.endDate) {
      dateTerm = 'NEXT_YEAR'
    } else if (this.fromToday) {
      if (endDate === this.TODAY) {
        dateTerm = Number(dateTerm) - 1
        dateTerm = dateTerm + '_FT'
      } else if (startDate === this.TODAY) {
        dateTerm = (Number(dateTerm) - 1) * -1
        dateTerm = dateTerm + '_FT'
      }
    } else if (endDate === this.TODAY) {
      dateTerm = Number(dateTerm) * -1
    }
    this.dateToggleGroup = dateTerm

    // console.log('dateToggleGroup', this.dateToggleGroup)
  }

  onChangeTerms(value) {
    if (value === undefined) {
      this.dateToggleGroup = undefined
    } else if (typeof value === 'string') {
      if (value === 'TODAY') {
        this.dateRange.startDate = this.TODAY
        this.dateRange.endDate = this.TODAY
      } else if (value === 'YESTERDAY') {
        this.dateRange.startDate = this.YESTERDAY
        this.dateRange.endDate = this.YESTERDAY
      } else if (value === 'TOMORROW') {
        this.dateRange.startDate = this.TOMORROW
        this.dateRange.endDate = this.TOMORROW
      } else if (value === 'THIS_WEEK') {
        this.dateRange.startDate = this.THIS_WEEK.startDate
        this.dateRange.endDate = this.THIS_WEEK.endDate
      } else if (value === 'LAST_WEEK') {
        this.dateRange.startDate = this.LAST_WEEK.startDate
        this.dateRange.endDate = this.LAST_WEEK.endDate
      } else if (value === 'NEXT_WEEK') {
        this.dateRange.startDate = this.NEXT_WEEK.startDate
        this.dateRange.endDate = this.NEXT_WEEK.endDate
      } else if (value === 'THIS_MONTH') {
        this.dateRange.startDate = this.THIS_MONTH.startDate
        this.dateRange.endDate = this.THIS_MONTH.endDate
      } else if (value === 'LAST_MONTH') {
        this.dateRange.startDate = this.LAST_MONTH.startDate
        this.dateRange.endDate = this.LAST_MONTH.endDate
      } else if (value === 'NEXT_MONTH') {
        this.dateRange.startDate = this.NEXT_MONTH.startDate
        this.dateRange.endDate = this.NEXT_MONTH.endDate
      } else if (value === 'THIS_QUARTER') {
        this.dateRange.startDate = this.THIS_QUARTER.startDate
        this.dateRange.endDate = this.THIS_QUARTER.endDate
      } else if (value === 'LAST_QUARTER') {
        this.dateRange.startDate = this.LAST_QUARTER.startDate
        this.dateRange.endDate = this.LAST_QUARTER.endDate
      } else if (value === 'NEXT_QUARTER') {
        this.dateRange.startDate = this.NEXT_QUARTER.startDate
        this.dateRange.endDate = this.NEXT_QUARTER.endDate
      } else if (value === 'THIS_YEAR') {
        this.dateRange.startDate = this.THIS_YEAR.startDate
        this.dateRange.endDate = this.THIS_YEAR.endDate
      } else if (value === 'LAST_YEAR') {
        this.dateRange.startDate = this.LAST_YEAR.startDate
        this.dateRange.endDate = this.LAST_YEAR.endDate
      } else if (value === 'NEXT_YEAR') {
        this.dateRange.startDate = this.NEXT_YEAR.startDate
        this.dateRange.endDate = this.NEXT_YEAR.endDate
      } else {
        const keyword = value.split('_')
        if (keyword[1] === 'FT') {
          let term = Number(keyword[0])
          if (term < 0) {
            term = Math.abs(term) - 1 === 0 ? 1 : Math.abs(term) - 1
            this.dateRange.startDate = moment().subtract(term, 'day').format('YYYY-MM-DD')
            this.dateRange.endDate = this.TODAY
          } else {
            term = Math.abs(term) - 1 === 0 ? 1 : Math.abs(term) - 1
            this.dateRange.startDate = this.TODAY
            this.dateRange.endDate = moment().add(term, 'day').format('YYYY-MM-DD')
          }
        } else if (keyword[1] === 'year') {
          let term = Number(keyword[0])
          if (term < 0) {
            term = Math.abs(term) * 365
            this.dateRange.startDate = moment(this.dateRange.endDate).subtract(term, 'day').format('YYYY-MM-DD')
          } else {
            term = Math.abs(term) * 365
            this.dateRange.endDate = moment(this.dateRange.startDate).add(term, 'day').format('YYYY-MM-DD')
          }
        } else if (keyword[1] === 'month') {
          let term = Number(keyword[0])
          if (term < 0) {
            term = Math.abs(term) * 30
            this.dateRange.startDate = moment(this.dateRange.endDate).subtract(term, 'day').format('YYYY-MM-DD')
          } else {
            term = Math.abs(term) * 30
            this.dateRange.endDate = moment(this.dateRange.startDate).add(term, 'day').format('YYYY-MM-DD')
          }
        } else if (keyword[1] === 'week') {
          let term = Number(keyword[0])
          if (term < 0) {
            term = Math.abs(term) * 7
            this.dateRange.startDate = moment(this.dateRange.endDate).subtract(term, 'day').format('YYYY-MM-DD')
          } else {
            term = Math.abs(term) * 7
            this.dateRange.endDate = moment(this.dateRange.startDate).add(term, 'day').format('YYYY-MM-DD')
          }
        }
      }
    } else if (typeof value === 'number') {
      if (value < 0) {
        value = Math.abs(value)
        const fromDate = moment(this.dateRange.endDate)
        // console.log('why!!!!!!!!!!!!!!!! minus - ', value, fromDate)
        this.dateRange.startDate = fromDate.subtract(value, 'day').format('YYYY-MM-DD')
        // this.dateRange.endDate = this.TODAY
      } else {
        // value = Math.abs(value)
        // this.dateRange.startDate = this.TODAY
        // TODO: number 이상한거 고치기
        const fromDate = moment(this.dateRange.startDate)
        // console.log('why!!!!!!!!!!!!!!!! plus - ', value, fromDate)
        this.dateRange.endDate = fromDate.add(value, 'day').format('YYYY-MM-DD')
      }
    }
  }

  @Watch('value', { deep: true })
  onValueChanged(val: DateRange) {
    this.dateRange = val
    this.onChangeDate()
    this.$emit('change', val)
    if (this.extendTerms) {
      this.$emit('changeTerms', this.dateToggleGroup)
    }
  }

  @Watch('dateRange', { deep: true })
  onDateRangeChanged(val: DateRange) {
    this.$emit('change', val)
  }

  @Watch('terms', { deep: true })
  onTermsChanged() {
    this.initToggleGroup()
  }

  @Watch('term', { deep: true })
  onTermChanged(val: number | string) {
    // this.onChangeTerms(val)
    console.log('init!! watch!!')
    this.dateToggleGroup = val
    this.onChangeTerms(this.dateToggleGroup)
  }

  @Watch('dateToggleGroup')
  onDateTermChanged(val: number | string) {
    this.onChangeTerms(val)
  }
}
